import type { StatusFinanceiro } from "@/modules/obras/obras.types";

export const NOVA_OBRA_ETAPAS = [
  { numero: 1, titulo: "Obra" },
  { numero: 2, titulo: "Duração" },
  { numero: 3, titulo: "Tipos de Obra" },
  { numero: 4, titulo: "Equipe" },
  { numero: 5, titulo: "Revisão" },
] as const;

export type NovaObraEtapa = (typeof NOVA_OBRA_ETAPAS)[number]["numero"];

export const PRIMEIRA_ETAPA: NovaObraEtapa = 1;
export const ULTIMA_ETAPA: NovaObraEtapa = 5;

export const DESCRICAO_MAX_LENGTH = 500;
export const OBSERVACOES_MAX_LENGTH = 500;

/** Dados da Etapa 1 "Dados da Obra" (HU 2519). */
export interface DadosObraEtapa1 {
  embarcacaoId: string | null;
  localPlanejadoId: string | null;
  /** Toggle; ativo = tipo 301 (RN06/RN07). */
  manutencaoCorretiva: boolean;
  statusObraId: string | null;
  /** FEL-0 automático com o toggle desligado; `null` = sem valor pré-selecionado (RN07). */
  statusFinanceiro: StatusFinanceiro | null;
  observacoes: string;
  descricao: string;
}

/**
 * Estado único do wizard, só no cliente (R3): nenhuma etapa persiste. As etapas
 * 2–5 guardam o seu snapshot em `etapas` (chaves abaixo) sem que a estrutura
 * precise conhecer o formato; o envio ao backend é do Salvar Rascunho e da Revisão.
 */
export type NovaObraEtapaExtra = "duracao" | "tiposObra" | "equipe";

export interface NovaObraState {
  etapaAtual: NovaObraEtapa;
  /** Maior etapa já alcançada: o stepper só libera o que já foi visitado. */
  maiorEtapaAlcancada: NovaObraEtapa;
  obra: DadosObraEtapa1;
  /** Snapshots das etapas 2–4 (HUs 2523, 2525/2528, 2530); `undefined` = ainda sem dados. */
  etapas: Partial<Record<NovaObraEtapaExtra, unknown>>;
  /**
   * HU 2549 (R3): justificativa única das condições pendentes (limite de classe e contrato), até
   * 500 caracteres. Só vai no POST/PUT (`justificativaCondicoes`) quando há pendência.
   */
  justificativaCondicoes: string;
  /** Etapas em que "Próxima etapa" já falhou: os erros passam a aparecer junto aos campos. */
  etapasComErroVisivel: NovaObraEtapa[];
}

export type ErrosEtapaObra = Partial<Record<keyof DadosObraEtapa1, string>>;
